import React from "react";
import styles from "./WasherProgramDetail.module.css";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";


const WasherProgramDetail = ({
  washerData,
  t,
  locale,
  handleClose,
  open,
}) => {

    const getDetergentType = (result) => {
      switch (result) {
        case 0:
          return "Enzymatic";
        case 1:
          return "Alkaline";
        case 2:
          return "No Ionic";
        default:
          return "";
      }
    };
  return (
    <ModalQ handleClose={handleClose} open={open} title={"Sterilizer Detail"}>
      <div className={styles.detailContainer}>
        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Name", locale) || "Name"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.programName || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Washer", locale) || "Washer"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.washer?.name || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Time", locale) || "Time"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.washingTime || "-"} {washerData.timeUnit || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Temperature", locale) || "Temperature"}:
            </label>
            <div className={styles.detailValue}>
            {washerData.temperature || "-"} {washerData.temperatureUnit || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("DisinfectionTime", locale) || "Disinfection Time"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.disinfectionTime || "-"} {washerData.disinfectionUnit || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("DetergentType", locale) || "Detergent Type"}:
            </label>
            <div className={styles.detailValue}>
              {getDetergentType(washerData.detergentType) || "-"}
            </div>
          </div>
        </div>


        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("DetergentConcentration", locale) || "Detergent Concentration"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.detergentConcentration || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("WaterPressure", locale) || "Water Pressure"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.waterPressure || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("waterHardness", locale) || "Water Hardness"}:
            </label>
            <div className={styles.detailValue}>
              {washerData.waterHardness || "-"}
            </div>
          </div>
        </div>
      </div>
    </ModalQ>
  );
};

export default WasherProgramDetail;